import React from 'react';
import { FaCheck, FaRocket, FaBolt, FaCrown, FaArrowRight } from 'react-icons/fa';
import styles from './PricingSection.module.css';
import Link from 'next/link';

import PricingCard from './PricingCard';

const PricingSection = () => {
    return (
        <section className={styles.pricingSection}>
            <div className={styles.pricingContainer}>
                <div className={styles.sectionHeader}>
                    <span className={styles.sectionLabel}>Hiring Solutions</span>
                    <h2 className={styles.sectionHeading}>Propel Your Talent Acquisition</h2>
                    <p className={styles.sectionText}>
                        Tailored options for every scale of recruitment. Experience high-velocity hiring with our flexible engagement models.
                    </p>
                </div>

                <div className={styles.gridThree}>
                    {/* Card 1: Free Tier */}
                    <PricingCard
                        subtitle="Get To Know Us"
                        title="Exploration Pass"
                        description="Test our complete AI toolkit for free and see how it revolutionizes your hiring workflows."
                        accentClass={styles.cardDiscovery}
                        featuresHeader="Included Tools"
                        featuresHeaderIcon={FaRocket}
                        featuresIconColor="#10b981"
                        features={[
                            "Collaborative Team Workspaces",
                            "Automated Scoring & Parsing",
                            "Custom Screening Logic",
                            "Unified Candidate Tracking"
                        ]}
                        buttonText="Start Free Trial"
                        buttonClass={styles.btnEmerald}
                    />

                    {/* Card 2: Credit Packs */}
                    <PricingCard
                        subtitle="Elastic Scale"
                        title="On-Demand Credits"
                        description="Perfect for seasonal hiring. Acquire credits that stay in your account until you are ready to use them."
                        accentClass={styles.cardFuel}
                        featuresHeader="Select Your Bundle"
                        featuresHeaderIcon={FaBolt}
                        featuresIconColor="#8b5cf6"
                        buttonText="Acquire Credits"
                        buttonClass={styles.btnPurple}
                    >
                        <div className={styles.featuresList} style={{ gap: '10px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', border: '1px solid #eee', borderRadius: '10px' }}>
                                <span style={{ fontWeight: '600', fontSize: '1.5rem' }}>Starter Pack</span>
                                <span style={{ fontWeight: '600' }}>1,000 Credits</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', border: '1px solid #eee', borderRadius: '10px' }}>
                                <span style={{ fontWeight: '600', fontSize: '1.5rem' }}>Growth Pack</span>
                                <span style={{ fontWeight: '600' }}>2,500 Credits</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', border: '1px solid #eee', borderRadius: '10px' }}>
                                <span style={{ fontWeight: '600', fontSize: '1.5rem' }}>Pro Pack</span>
                                <span style={{ fontWeight: '600' }}>4,000 Credits</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', border: '1px solid #eee', borderRadius: '10px' }}>
                                <span style={{ fontWeight: '600', fontSize: '1.5rem' }}>Enterprise Pack</span>
                                <span style={{ fontWeight: '600' }}>10,000 Credits</span>
                            </div>
                        </div>
                    </PricingCard>

                    {/* Card 3: Subscription */}
                    <PricingCard
                        badgeText="STRATEGIC CHOICE"
                        subtitle="Sustainable Value"
                        title="Managed Subscription"
                        description="Our most cost-effective path for teams with continuous recruitment needs and high volume."
                        accentClass={styles.cardDominance}
                        featuresHeader="Premium Experience"
                        featuresHeaderIcon={FaCrown}
                        featuresIconColor="#3b82f6"
                        checkIconClass={styles.blueCheck}
                        features={[
                            "All Tools + Monthly Credits",
                            "Optimal ROI for Active Teams",
                            "On-Demand Scalable Top-ups",
                            "Adaptive Plan Migration",
                            "Concierge Support Access"
                        ]}
                        buttonText="Upgrade Now"
                        buttonClass={styles.btnBlue}
                    />
                </div>
            </div>
        </section>
    );
};

export default PricingSection;
